// Function to get cookie value by key
export function getCookie(key) {
    const cookies = document.cookie.split(';');
    for (let cookie of cookies) {
        let [cookieKey, cookieValue] = cookie.split('=');
        if (cookieKey.trim() === key) {
            return cookieValue;
        }
    }
    return null;
}

// Function to delete cookie by key
export function deleteCookie(key) {
    document.cookie = key + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
}